var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMembershipCrown = function SvgMembershipCrown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3021 17.1093H3.69766C3.15768 17.1093 2.68697 16.7417 2.55604 16.2179L0.0351561 6.13429C-0.0762449 5.68845 0.0819922 5.21852 0.440515 4.931C0.79896 4.64332 1.29203 4.59091 1.70311 4.79638L5.77019 6.82992L8.99094 1.46203C9.20362 1.10759 9.58662 0.890747 9.99998 0.890747C10.4133 0.890747 10.7963 1.10767 11.009 1.46203L14.2298 6.82992L18.2969 4.79638C18.7077 4.59083 19.2008 4.64332 19.5595 4.931C19.918 5.21852 20.0763 5.68845 19.9648 6.13429L17.4438 16.2179C17.3128 16.7417 16.8421 17.1093 16.3021 17.1093Z",
    fill: "#FFD71B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3022 17.1093C16.8422 17.1093 17.3129 16.7417 17.4439 16.2179L19.9648 6.13429C20.0763 5.68845 19.918 5.21852 19.5595 4.931C19.2009 4.64332 18.7078 4.59083 18.2969 4.79638L14.2298 6.82992L11.009 1.46203C10.7964 1.10759 10.4133 0.890747 10 0.890747L10 17.1093H16.3022Z",
    fill: "#FFB700"
  })));
};
export default SvgMembershipCrown;